import { createRoute, redirect } from "@tanstack/react-router";

import { root } from "routes";
import Layout from "theme/ui/Layout";
import Login from "./pages/Login";


const _root = createRoute({
	getParentRoute: () => root,
	path: "auth",
	component: () => <Layout.Auth />
});

const login = createRoute({
	getParentRoute: () => _root,
	path: "/",
	component: () => <Login />,
	beforeLoad: ({ context }) => {
		if (context.auth0?.isAuthenticated) throw redirect({ to: "/" });
	},
	staticData: {
		lite: true
	}
});


const auth = _root.addChildren([login]);
export default auth;